const polyfills: Promise<any>[] = [];

if (!window.URL || !window.URLSearchParams) {
  polyfills.push(
    import(/* webpackChunkName: "noprefetch-url-polyfill" */ 'url-polyfill')
  );
}

if (!('innerSVG' in SVGElement.prototype)) {
  polyfills.push(
    import(
      /* webpackChunkName: "noprefetch-innersvg-polyfill" */ 'innersvg-polyfill'
    )
  );
}

export default polyfills;
